export const mediaQueries = [
	'(max-width: 599px)', // isSmall
	'(min-width: 600px) and (max-width: 1023px)', // isMedium
	'(min-width: 1024px) and (max-width: 1919px)', // isLarge
	'(min-width: 1920px)', // isExtraLarge
]
